/**
 * Darkens a hex color code by a given amount.
 * @param {string} hex - The hex color code to darken.
 * @param {number} amount - The amount to darken the color by (default is 10).
 * @returns {string} The darkened hex color code.
 */
export function darkenHexColor(hex, amount = 50) {
  let color = hex.startsWith('#') ? hex.slice(1) : hex;
  const num = parseInt(color, 16);

  let r = (num >> 16) - amount;
  let g = ((num >> 8) & 0x00ff) - amount;
  let b = (num & 0x0000ff) - amount;

  r = r < 0 ? 0 : r;
  g = g < 0 ? 0 : g;
  b = b < 0 ? 0 : b;

  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

/**
 * Gets the theme color.
 * @param {string} color - The color prop.
 * @param {object} theme - The MUI theme object.
 * @returns {string} The resolved color color.
 */
export function getThemeColor(color, theme) {
  if (color === 'primary' || color === 'primary.main') {
    return theme.palette.primary.main;
  }
  if (color === 'secondary' || color === 'secondary.main') {
    return theme.palette.secondary.main;
  }
  if (color === 'text') {
    return theme.palette.text.secondary;
  }
  return color;
}

/**
 * Gets the font family by string from the theme.
 * @param {string} fontFamily - The font family ("heading.fontFamily.primary", "body.fontFamily.primary", "body.fontFamily.secondary", "heading.fontFamily.secondary").
 * @param {object} theme - The MUI theme object.
 * @returns {string} The resolved font family.
 */
export function getFontFamily(fontFamily, theme) {
    // Early return for non-dot notation or invalid input
    if (!fontFamily || !fontFamily.includes(".")) {
        return fontFamily;
    }

    const fontFamilyArray = fontFamily.split(".");
    let fontFamilyObject = theme?.typography;

    // Validate theme structure and array length
    if (!fontFamilyObject || fontFamilyArray.length <= 1) {
        return fontFamily;
    }

    // Traverse the path with proper validation
    for (const fontFamilyKey of fontFamilyArray) {
        if (fontFamilyObject && typeof fontFamilyObject === 'object' && fontFamilyKey in fontFamilyObject) {
            fontFamilyObject = fontFamilyObject[fontFamilyKey];
        } else {
            // If any key in the path doesn't exist, return original fontFamily
            return fontFamily;
        }
    }

    return fontFamilyObject;
}
